{
  "accept": "*",
  "wrongType": "Uploaded file must be in ${accepts} format!",
  "dropDown": "Click to show all attachments",
  "uploadIcon": "fas fa-upload",
  "uploadText": "Browse",
  "uploadTooltip": "Choose file to upload",
  "removeIcon": "fa-solid fa-trash",
  "removeText": "Remove {file}?",
  "removeTooltip": "Remove",
  "exceedLimit": "Selected files exceed the limit:",
  "removePrompt": "Are you sure you want to remove {file}?"
}